import { getLocale } from '@/locales/locale';
import { request } from 'ice';

export const getWarehouse = async () => {
  console.log('getLocale', getLocale());
  const data = getLocale() === 'zh-CN' ? 'CN' : 'EN';
  console.log('d', data);
  return await request({
    url: `giws-basic/rpc/warehouse/getWarehouseByRegionalAndUser?lan=${data}`,
    method: 'GET',
  });
};

// export const getWarehouse = async (data) => {
//   return await request({
//     url: 'giws-basic/rpc/warehouse/getAreaInfo',
//     method: 'POST',
//     data,
//   });
// };
